export enum EnumUrlsPages {
  about = '/companya/',
  gallery = '/fotogalereya/',
  delivery = '/uslugi/',
  policy = '/politika-konfidenczialnosti/',
  tracking = '/tracking/',
  calculator = '/calculator/',
  contacts = '/contacts/',
  story = '/story/',
  questions = '/clients/voprosy-o-dostavke/',
  docs = '/clients/dokumenty/',
  live = '/blog/',
  vacancies = '/vacancy/',
  reviews = '/otzyvy/',
  partners = '/partners/',
  clients = '/companya/nashi-klienty/',
  cashService = '/clients/kassovoe-obsluzhivanie/',
  returnDocuments = '/docs-return/',
  integration = '/clients/lichnyy-kabinet/',

  deliveryMsk = '/courier-delivery-msk/',
  deliveryMskToSpb = '/courier-delivery-spb/',
  deliverySameDay = '/delivery-same-day/',
  deliveryShipFromStore = '/ship-from-store/',
  deliveryRu = '/agregator-dostavki-dlya-internet-magazinov/',
  deliveryPVZ = '/punkty-vydachi-zakazov/',
  deliveryInternet = '/dostavka-dlya-internet-magazinov/',
  deliveryB2B = '/dostavka-b2b/',
  deliveryMarketplace = '/dostavka-tovarov-na-marketpleysy/',
  deliveryForLegal = '/dostavka-dlya-yuridicheskikh-lits-i-organizatsiy/',
  deliveryFiliali = '/filialy-kompanii-dalli/',

  deliveryOutsourcing = '/autsorsing-internet-magazinov/',
  deliveryComprehensiveService = '/obsluzhivanie-internet-magazinov/',
  deliveryLogistics = '/logistika-dlya-internet-magazina/',
  deliverySpb = '/dostavka-po-spb/',
  deliveryNextDay = '/delivery-next-day/',

  deliverySZFO = '/dostavka-severo-zapadnyy-federalnyy-okrug/',
  deliveryCFO = '/dostavka-centralnyy-federalnyy-okrug/',
  deliveryUFO = '/dostavka-yuzhnyy-federalnyy-okrug/',
  deliveryPFO = '/dostavka-privolzhskij-federalnyj-okrug/',
  deliveryUrFO = '/dostavka-uralskiy-federalnyy-okrug/',
  deliverySbFO = '/dostavka-sibirskiy-federalnyy-okrug/',
  deliverySK = '/dostavka-v-severo-kavkazskiy-federalniy-okrug/'  ,

  notFound = '/not-found',
}
